import {ReactSVG} from "react-svg";
import "./EventLogo.css"

// TODO rename to something that covers both events and match prefixes after FCMP
export default function EventLogo({logo}: {logo?: string}) {
    if(!logo) {
        return
    }

    return <ReactSVG className={"eventLogo"} wrapper={"span"} src={`data:image/svg+xml;utf8,${encodeURIComponent(logo)}`} />;
}